import AppRoutes from "./routes/AppRoutes";
import RouteScrollManager from "./components/common/RouteScrollManager/RouteScrollManager";
import OrganizationSchema from "./components/common/OrganizationSchema/OrganizationSchema";
import CookieConsent from "./components/common/CookieConsent/CookieConsent";
import { MotionProvider } from "./components/common/Motion";
import { RecruitmentModalProvider } from "./components/common/RecruitmentModal/RecruitmentModal";

function App() {
  return (
    <RecruitmentModalProvider>
      <MotionProvider>
        <OrganizationSchema />
        <RouteScrollManager />
        <AppRoutes />
        <CookieConsent />
      </MotionProvider>
    </RecruitmentModalProvider>
  );
}

export default App;
